The input parameter for the `sendSignals` mutation.
